<div class="row">

    <div class="col-lg-6">
        <div class="border rounded">
            <a href="#">
                <img [src]="product?.imagen?.url" class="img-fluid rounded" alt="Image">
            </a>
        </div>
    </div>
    <div class="col-lg-6">
        <h4 class="fw-bold mb-3">{{product?.nombre}}</h4>
        <p class="mb-3">SKU: {{product?.sku}}</p>
        <p class="mb-3">Categoria: {{product?.categoria[0]?.nombre}}</p>
        <h5 class="fw-bold mb-3">Precio Unitario: {{product?.precioUnitario | currency}}</h5>
        <h5 class="fw-bold mb-3">Precio de Lista: {{product?.precioLista | currency}}</h5>
        <div class="d-flex mb-4">
            <i class="fa fa-star text-secondary"></i>
            <i class="fa fa-star text-secondary"></i>
            <i class="fa fa-star text-secondary"></i>
            <i class="fa fa-star text-secondary"></i>
            <i class="fa fa-star"></i>
        </div>
        <div class="mb-4" [innerHtml]="product?.descripcionCorta "></div>
        <div class="input-group quantity" style="width: 100px;">
            <div class="input-group-btn">
                <button class="btn btn-sm btn-minus rounded-circle bg-light border">
                  <i class="fa fa-minus"></i>
              </button>
            </div>
            <input type="text" class="form-control form-control-sm text-center border-0" value="1">
            <div class="input-group-btn">
                <button class="btn btn-sm btn-plus rounded-circle bg-light border">
                  <i class="fa fa-plus"></i>
              </button>
            </div>
        </div>
        <a href="#" class="btn border border-secondary rounded-pill px-4 py-2 mb-4 text-primary"><i class="fa fa-shopping-bag me-2 text-primary"></i> Agregar al carrito</a>
    </div>
    <div class="col-lg-12">
        <nav>
            <div class="nav nav-tabs mb-3">
                <button class="nav-link active border-white border-bottom-0" type="button" role="tab" id="nav-about-tab" data-bs-toggle="tab" data-bs-target="#nav-about" aria-controls="nav-about" aria-selected="true">Descripción</button>
            </div>
        </nav>
        <div class="tab-content">
            <div class="tab-pane active" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                <div [innerHtml]="product?.descripcion.html"></div>
                <div class="px-2">
                    <div class="row g-4">
                        <div class="col-6">
                            <div class="row bg-light align-items-center text-center justify-content-center py-2">
                                <div class="col-6">
                                    <p class="mb-0">Formato</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0">{{product?.formato}}</p>
                                </div>
                            </div>
                            <div class="row bg-light text-center align-items-center justify-content-center py-2">
                                <div class="col-6">
                                    <p class="mb-0">Especimen/Muestra</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0">{{product?.especimen}}</p>
                                </div>
                            </div>
                            <div class="row bg-light align-items-center text-center justify-content-center py-2">
                                <div class="col-6">
                                    <p class="mb-0">Presentación</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0">{{product?.presentacion}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>